export const SET_CHATBOT_STATE = 'SET_CHATBOT_STATE';

export function setChatbotState(data) {
  return {
    type: SET_CHATBOT_STATE,
    data,
  };
}
